import { CoverContent } from '@bnnvara/cards/src/components/deprecated/GridCard/CoverContent/CoverContent';
import {
  GridCard,
  LAYOUT_MINIMAL,
  LAYOUT_RECTANGLE,
  LAYOUT_SQUARE,
} from '@bnnvara/cards/src/components/deprecated/GridCard/GridCard';
import { ImageWithTextCard } from '@bnnvara/cards/src/components/ImageWithTextCard/ImageWithTextCard';
import { CommentCount } from '@bnnvara/cards/src/components/shared/CommentCount';
import { ContentOnImage } from '@bnnvara/cards/src/components/shared/ContentOnImage';
import { HideOnSmallDevices } from '@bnnvara/cards/src/components/shared/HideOnSmallDevices';
import { OnHoverTextEffect } from '@bnnvara/cards/src/components/shared/OnHoverTextEffect';
import { Small } from '@bnnvara/cards/src/components/shared/Small';
import { Title } from '@bnnvara/cards/src/components/shared/Title';
import { formatDate } from '@bnnvara/helpers';
import { CommentIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/CommentIcon';
import { SlotContent } from '@bnnvara/slot/src/component/SlotContent';
import PropTypes from 'prop-types';
import React from 'react';

import resizeImageSource from '../../../helpers/resizeImageSource';

export const ArticleCard = ({
  title,
  publishDate,
  thumbnail,
  commentCount,
  commentsEnabled,
  labelName,
  layout,
}) => {
  const image = thumbnail.url || '/static/fallbackImages/videofallback.jpg';
  const pubDate = formatDate(publishDate);
  const backgroundImage = resizeImageSource(image, 500, 1);

  if (layout === null) {
    return (
      <ImageWithTextCard
        aria-label={labelName}
        image={{
          isLazyLoaded: true,
          alt: title,
          src: backgroundImage,
        }}
      >
        <SlotContent slot="image">
          {commentCount > 0 && commentsEnabled && (
            <CommentCount>
              <CommentIcon />
              {commentCount}
            </CommentCount>
          )}
          <HideOnSmallDevices>
            <ContentOnImage>
              <Title>{title}</Title>
              <Small>{pubDate}</Small>
            </ContentOnImage>
          </HideOnSmallDevices>
        </SlotContent>

        <SlotContent slot="text">
          <OnHoverTextEffect>
            <Title>{title}</Title>
          </OnHoverTextEffect>
          <Small>{pubDate}</Small>
        </SlotContent>
      </ImageWithTextCard>
    );
  }
  return (
    <GridCard layout={layout} aria-label={labelName}>
      <CoverContent
        title={title}
        pubDate={pubDate}
        backgroundImage={backgroundImage}
        commentCount={commentCount}
        commentsEnabled={commentsEnabled}
      />
    </GridCard>
  );
};

ArticleCard.defaultProps = {
  thumbnail: null,
  commentCount: 0,
  layout: null,
};

ArticleCard.propTypes = {
  thumbnail: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  title: PropTypes.string.isRequired,
  publishDate: PropTypes.string.isRequired,
  commentCount: PropTypes.number,
  commentsEnabled: PropTypes.string,
  labelName: PropTypes.string,
  layout: PropTypes.shape({
    mobile: PropTypes.oneOf([LAYOUT_MINIMAL, LAYOUT_SQUARE]),
    tablet: PropTypes.oneOf([LAYOUT_MINIMAL, LAYOUT_RECTANGLE, LAYOUT_SQUARE]),
    desktop: PropTypes.oneOf([LAYOUT_RECTANGLE, LAYOUT_SQUARE]),
  }),
};

export default ArticleCard;
